<p-card>
  <p-steps [model]="(stepsService.steps$ | async)!" [readonly]="false"></p-steps>
</p-card>
